/**
 * Centralized SEO configuration for all routes
 * Used by:
 * - SEO component for meta tags
 * - generate-sitemap.js for sitemap generation
 *
 * Data is stored in seoRoutes.json for CommonJS compatibility
 */

import seoRoutesData from './seoRoutes.json';

export interface SEORouteConfig {
  path: string;
  title: string;
  description: string;
  changefreq: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  priority: number;
  noIndex?: boolean;
}

export const SEO_ROUTES: SEORouteConfig[] = seoRoutesData as SEORouteConfig[];

// Map for quick lookup by path
export const SEO_ROUTES_MAP: Record<string, SEORouteConfig> = SEO_ROUTES.reduce(
  (acc, route) => {
    acc[route.path] = route;
    return acc;
  },
  {} as Record<string, SEORouteConfig>
);
